export const count = (source, predicate) => {
    if (predicate) {
        return count2(source, predicate);
    }
    else {
        return count1(source);
    }
};
const count1 = (source) => {
    let count = 0;
    for (const _ of source) {
        count++;
    }
    return count;
};
const count2 = (source, predicate) => {
    let count = 0;
    for (const value of source) {
        if (predicate(value) === true) {
            count++;
        }
    }
    return count;
};
